import React from 'react';
import { useMediaQuery } from 'react-responsive';
import JobsContent from './JobsContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <JobsContent history={history} />
  </Mobile>
);

export default MobileResponsive;
